import axios from 'axios';
import { store } from '../app/store';
import { getCurrentGroupId, getManagerId } from '../utils/functions';
import { setUser } from '../app/features/auth';
const api = axios.create({
    baseURL: process.env.REACT_APP_URL,
});
export const authApi = axios.create({
    baseURL: process.env.REACT_APP_URL,
});
authApi.interceptors.request.use((config) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    config.headers = {
        ...config.headers,
        'ngrok-skip-browser-warning': '69420',
    };
    return config;
});
export const authInterceptor = async (config) => {
    const token = store.getState().authSlicer.user.token;
    if (!token)
        throw new Error('token not found');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    else {
        // eslint-disable-next-line quotes
        throw new Error("User isn't authenticated.");
    }
    return config;
};
const refreshTokenSignIn = async () => {
    try {
        const user = store.getState().authSlicer.user;
        const dispatch = store.dispatch;
        if (!user) {
            throw new Error('User not found.');
        }
        const { data } = await api.post('api/LoginPdc/RefreshToken', {
            accessToken: user.token,
            refreshToken: user.refreshToken,
        });
        dispatch(setUser({
            user: {
                ...user,
                token: data.accessToken,
                refreshToken: data.refreshToken,
            },
        }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (e) {
        if (e.response.data === 'Invalid access token or refresh token') {
            throw new Error('Expired');
        }
        throw new Error('Serviço indisponível, tente novamente mais tarde.');
    }
};
let refreshingFunc = undefined;
const refreshAuthInterceptor = async (error) => {
    if (error.response?.status !== 401)
        return Promise.reject(error);
    const originalConfig = error.config;
    try {
        if (!refreshingFunc)
            refreshingFunc = refreshTokenSignIn();
        await refreshingFunc;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return await authApi.request(originalConfig);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (e) {
        throw new Error('Expired');
    }
    finally {
        refreshingFunc = undefined;
    }
};
// Auth
authApi.interceptors.request.use(authInterceptor);
//Refresh
authApi.interceptors.response.use(undefined, refreshAuthInterceptor);
const downloadSheet = async (file, id, mediationId, costCenter) => {
    const groupId = getCurrentGroupId();
    switch (file) {
        case 'models':
            return authApi.get(`api/Frota/Modelos/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'general':
            return authApi.get(`api/Frota/Geral/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'age':
            return authApi.get(`api/Frota/Idade/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'km':
            return authApi.get(`api/Frota/Km/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'averageKm':
            return authApi.get(`api/Frota/KmMedio/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'entranceExit':
            return authApi.get(`api/Frota/Manutencao/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'repair':
            return authApi.get(`api/Frota/Servicos/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'schedule':
            return authApi.get(`api/Frota/Agendamento/${groupId}/Download`, {
                responseType: 'arraybuffer',
            });
        case 'financial':
            return authApi.get(`api/faturamento/Baixar/${mediationId}`, {
                params: { anexoId: id, costCenter: costCenter },
                responseType: 'arraybuffer',
            });
        case 'vehicles':
            return authApi.get('api/crlv/Download', {
                params: {
                    chassi: id,
                    gestorId: getManagerId(),
                    grupoId: getCurrentGroupId(),
                },
                responseType: 'arraybuffer',
            });
        case 'selectedVehicles':
            return authApi.get(`api/crlv/Download/Varios?${id}`, {
                responseType: 'arraybuffer',
                params: { gestorId: getManagerId(), grupoId: getCurrentGroupId() },
            });
        case 'allVehicles':
            return authApi.get('api/crlv/Download/Todos', {
                params: { gestorId: getManagerId(), grupoId: getCurrentGroupId() },
                responseType: 'arraybuffer',
            });
        case 'ErrorsCrlv':
            return authApi.get('api/Logpdc/ErrosCrlv', {
                responseType: 'arraybuffer',
            });
        default:
            break;
    }
};
export { api, downloadSheet };
